import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=49276124&scoped=true"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"
import style0 from "./headline.vue?vue&type=style&index=0&id=49276124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49276124",
  null
  
)

export default component.exports